import { config, gallery, screens, socials } from "../utils";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <>
      <div
        className="container-fluid bg-dark text-body footer mt-5 pt-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-4 col-md-6">
              <h5 className="text-white mb-4">Address</h5>
              <p className="mb-2">
                <i className="fa fa-map-marker-alt me-1"></i>
                {`${config.address1} ${config.address2} ${config.address3}`}
              </p>
              {/*  <p className="mb-2">
                <i className="fa fa-phone-alt me-3"></i>
                {config.phoneNo}
              </p> */}
              <p className="mb-2">
                <i className="fa fa-envelope me-1"></i>
                {config.email}
              </p>
              <div className="d-flex pt-2">
                {socials.map((social, index) => {
                  return (
                    <Link
                      key={index}
                      className={`btn btn-square btn-outline-light btn-social ${
                        index > 0 ? "ms-2" : ""
                      }`}
                      to={social.url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className={`fab ${social.icon}`}></i>
                    </Link>
                  );
                })}
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <h5 className="text-white mb-4">Quick Links</h5>
              {screens.map((menu, index) => {
                return (
                  <Link className="btn btn-link" to={menu.url} key={index}>
                    {menu.pageName}
                  </Link>
                );
              })}
            </div>
            <div className="col-lg-4 col-md-6">
              <h5 className="text-white mb-4">Our Gallery</h5>
              <div className="row g-2">
                {gallery.slice(0, 6).map((x, index) => {
                  return (
                    <div className="col-4" key={index}>
                      <img
                        className="img-fluid rounded"
                        // src="img/gallery-1.jpg"
                        src={x.img}
                        alt={x.name}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
            {/*  <div className="col-lg-3 col-md-6">
              <h5 className="text-white mb-4">Newsletter</h5>
              <p>Dolor amet sit justo amet elitr clita ipsum elitr est.</p>
              <div className="position-relative mx-auto">
                <input
                  className="form-control border-0 w-100 py-3 ps-4 pe-5"
                  type="text"
                  placeholder="Your email"
                />
                <button
                  type="button"
                  className="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2"
                >
                  SignUp
                </button>
              </div>
            </div> */}
          </div>
        </div>
        <div className="container">
          <div className="copyright">
            <div className="row">
              <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                &copy; {config.appName} All Right Reserved.
              </div>
              <div className="col-md-6 text-center text-md-end">
                Designed By <a href="https://htmlcodex.com">HTML Codex</a>
                <br />
                Distributed By
                <a href="https://themewagon.com">ThemeWagon</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Footer;
